import TbCardsMenu from './TbCardsMenu';

export default TbCardsMenu;
